import React from "react";
import { Link } from "react-router-dom";
import logo from "../../images/vic-govt-logo-original.png";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import "./Header.scss";

function Header(props) {
  return (
    <>
      <MDBRow className="top-header">
        <MDBCol>
          <MDBContainer>
            <div>
              <Link to={"/"} className="header-logo nav-link">
                <img className="logo" src={logo} alt="State Government Logo" />
              </Link>
            </div>
          </MDBContainer>
        </MDBCol>
      </MDBRow>
      <MDBRow className="sub-header">
        <MDBCol>
          <MDBContainer>
            <div>
              <span className="sub-header-text">
                Object to rating valuation
              </span>
            </div>
          </MDBContainer>
        </MDBCol>
      </MDBRow>
    </>
  );
}

export default Header;
